<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Kategóriák</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/data/categories/add')"
            icon="el-icon-plus"
            v-can="'data.productcategory.create'"
          >
            Új Kategória
          </el-button>
        </div>
        <list />
        <template v-if="$route.meta.showAddCategoryDialog">
          <category-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateCategoryDialog">
          <category-dialog
            :productCategoryId="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../../components/data/products/Sidebar';
  import List from '../../../components/data/products/categories/List';
  import CategoryDialog from '../../../components/data/products/categories/Dialog';

  export default {
    components: {
      Sidebar,
      List,
      CategoryDialog,
    }
  };
</script>
